@let page = currentPage();

<ng-template #buttonBar>
    <div
        class="container my-4 grid grid-cols-12 sm:gap-6"
        [class.max-lg:max-w-full]="isEmbeddedInMobileApp()">
        <div
            class="col-span-12 flex items-center"
            [class]="{
                'md:col-span-8': isWizardShown(),
                'md:col-start-5': isWizardShown(),
            }">
            @if (isBackButtonAvailable() && !isSkipFormStepButtonAvailable() && !hasOwnSubmitButtonBar()) {
                <big-ui-button
                    (clicked)="backButtonHandler($event)"
                    [disabled]="isTransmitting() || isPageNavigationBusy()"
                    [type]="'button'"
                    [buttonStyle]="'tertiary'"
                    [classList]="['flex items-center']">
                    <big-icon
                        [icon]="iconArrowLeft"
                        [size]="'w-5'"
                        class="mr-2 dark:fill-white" />
                    <span>{{ backButtonLabel() | stringReplacePipe }}</span>
                </big-ui-button>
            }
            @if (isSkipFormStepButtonAvailable() && !isBackButtonAvailable() && !hasOwnSubmitButtonBar()) {
                <big-ui-button
                    (clicked)="skipFormStepButtonHandler($event)"
                    [disabled]="isTransmitting() || isPageNavigationBusy()"
                    [type]="'button'"
                    [buttonStyle]="'tertiary'"
                    [classList]="['flex items-center']">
                    <span>{{ skipFormStepButtonLabel() }}</span>
                </big-ui-button>
            }
            @if (isNextPageAvailable() && !hasOwnSubmitButtonBar()) {
                <big-ui-button
                    [buttonStyle]="'primary'"
                    class="ml-auto"
                    [type]="'submit'"
                    (clicked)="onSubmit($event)"
                    [disabled]="isTransmitting() || isPageNavigationBusy()"
                    [classList]="['flex items-center gap-2']">
                    @if (isTransmitting()) {
                        <big-ui-spinner
                            [spinnerClass]="'inline-flex mt-0.5 align-text-top'"
                            [size]="'s'"
                            [color]="'primary'" />
                    }
                    <span>{{ nextButtonLabel() | stringReplacePipe }}</span>
                </big-ui-button>
            }
        </div>
    </div>
</ng-template>

@if (isLoadingData()) {
    <big-form-initial-loading />
}
<big-error-handling-alert
    [errorCode]="formError()"
    errorType="form" />

<div [class.hidden]="isLoadingData() || formError()">
    @if (!isTransmissionSuccessful()) {
        <big-ui-user-data
            (hasUserData)="hasUserData.set($event)"
            [viewMode]="'inline'"
            [class.hidden]="!hasUserData()"
            class="mb-12 block md:hidden" />
    }

    <form
        [formGroup]="currentForm"
        (ngSubmit)="onSubmit($event)">
        @if (isNextPageAvailable()|| isFormShown()) {
            @for (markup of topLevelMarkups; track $index) {
                <big-form-markup [settings]="markup" />
            }
        }
        @if (page) {
            <big-form-page [settings]="page.settings" />
        }
        @if (isBackButtonAvailable() || isNextPageAvailable()) {
            <div [class.mt-4]="!isFormShown()" [class.pt-4]="!isFormShown()">
                <div
                    class="h-20"
                    (bigSharedIsInViewport)="formButtonsInViewport.set($event)"
                    [threshold]="1">
                    <div class="absolute right-0 left-0">
                        <ng-template [ngTemplateOutlet]="buttonBar"></ng-template>
                    </div>
                </div>
                @if (isFormShown()) {
                    <div
                        class="h-sm:hidden dark:bg-primary-800 border-primary-200/50 fixed inset-x-0 bottom-0 z-(--z-fixed) border-t-2 bg-white"
                        [class.block]="!formButtonsInViewport()"
                        [class.hidden]="formButtonsInViewport()">
                        <ng-template [ngTemplateOutlet]="buttonBar"></ng-template>
                    </div>
                }
            </div>
        }

        @if (afterCompletedCallback() && isTransmissionSuccessful()) {
            <div>
                <big-ui-button
                    (clicked)="afterCompletedCallback()?.()"
                    [buttonStyle]="'secondary'"
                    [classList]="['enabled:hover:text-primary-light']">
                    <span>{{ afterCompletedText }}</span>
                </big-ui-button>
            </div>
        }
    </form>
</div>

@if (!isEmbeddedInMobileApp() && page && page.settings?.faqGroupNode) {
    <div class="mt-12">
        <big-form-faq [faqNodeId]="page.settings.faqGroupNode" />
    </div>
}

<!-- Spacer fixed footer while form is rendered with fixed header and footer -->
@if (!isLoadingData() && !formError() && isFormShown()) {
    <div class="my-3.5 h-10"></div>
}

@if (showFormState()) {
    <big-form-state-preview />
}
